<template>
<div class="chapter">
<div class="inner_page">
<h3 class="books-by-head"><em>Recent Titles by Pamela Oldfield from Severn House</em></h3>
<p class="books-by-text"><em>The Heron Saga</em></p>
<p class="books-by-text">BETROTHED</p>
<p class="books-by-text">THE GILDED LAND</p>
<p class="books-by-text">LOWERING SKIES</p>
<p class="books-by-text-space-after">THE BRIGHT DAWNING</p>
<div> </div>
<p class="books-by-text">ALL OUR TOMORROWS</p>
<p class="books-by-text">EARLY ONE MORNING</p>
<p class="books-by-text-space-after">RIDING THE STORM</p>
<p class="books-by-text">CHANGING FORTUNES</p>
<p class="books-by-text">NEW BEGINNINGS</p>
<p class="books-by-text-space-after">MATTERS OF TRUST</p>
<p class="books-by-text">DANGEROUS SECRETS</p>
<p class="books-by-text">INTRICATE LIAISONS</p>
<p class="books-by-text-space-after">TURNING LEAVES</p>
<p class="books-by-text">HENRY’S WOMEN</p>
<p class="books-by-text">SUMMER LIGHTNING</p>
<p class="books-by-text">JACK’S SHADOW</p>
<p class="books-by-text">FULL CIRCLE</p>
<p class="books-by-text">LOVING AND LOSING</p>
<p class="books-by-text">FATEFUL VOYAGE</p>
<p class="books-by-text">THE LONGEST ROAD</p>
<p class="books-by-text">THE FAIRFAX LEGACY</p>
<p class="books-by-text">TRUTH WILL OUT</p>
<p class="books-by-text">THE BIRTHDAY PRESENT</p>
<p class="books-by-text">THE BOAT HOUSE</p>
<p class="books-by-text">THE PENNINGTONS</p>
<p class="books-by-text">THE GREAT BETRAYAL</p>
<p class="books-by-text">ISABEL’S WEDDING</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// alsoby.vue?400ed444